import React, { type HTMLAttributes } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { clsx } from '@soulhx/ui-common';
import { quickID } from '@soulhx/fs-common';

type ICopyrightInfo = {
  copyrightStrings: Record<string, string>;
} & HTMLAttributes<HTMLDivElement>;
export const CopyrightInfo = ({ copyrightStrings, className, ...props }: ICopyrightInfo) => {
  const { t } = useTranslation(['bibleviewer']);

  const entries = Object.entries(copyrightStrings);
  if (entries.length < 1) return null;

  return (
    <div className={clsx('copyright-container', className)} {...props}>
      <h6>{t('bibleviewer:copyright.title')}</h6>

      {entries.map(([key, value]) => (
        <div key={quickID()} className="copyright-row">
          <Trans
            i18nKey="bibleviewer:copyright.entry"
            values={{ key, value }}
            shouldUnescape
            components={{ strong: <strong /> }}
          />
        </div>
      ))}
    </div>
  );
};
